import * as THREE from 'three';
import { TILE_SIZE } from '../../labyrinth/Labyrinth';
import { applyStylizedShading, type LightmapBindings } from '../StylizedShading';

export const WEAPON_W = TILE_SIZE * 0.12;
export const WEAPON_H = TILE_SIZE * 0.10;
export const WEAPON_L = TILE_SIZE * 0.30;

const COLOR = 0x1f2228;

const SHADING = {
  lightmapNormalOffset: false,
  keyLightStrength: 0.30,
  rimStrength: 0.55,
  rimPower: 2.5,
  verticalAOStrength: 0.22,
} as const;

const SKIN = {
  panelScale: 0.95, etchStrength: 0.32, ledDensity: 0.14,
  conduitStrength: 0.55, trimHue: 0.78, // magenta-violet
} as const;

export interface RobotWeaponPart {
  /** Weapon mesh — the rig positions and toggles visibility per occupied slot. */
  readonly object: THREE.Mesh;
  dispose(): void;
}

/**
 * Procedural weapon box. Each instance gets a unique skin `seed` so the six
 * weapon slots (4 main + 2 hardpoints) don't blink in unison. To swap with a
 * Blender model, keep WEAPON_L meaningful (the rig offsets main weapons by
 * `WEAPON_L / 2` along local +X so they extend out from the turret) or bake
 * the offset into the model origin.
 */
export function createRobotWeapon(lightmap: LightmapBindings, seed: number): RobotWeaponPart {
  const geo = new THREE.BoxGeometry(WEAPON_L, WEAPON_H, WEAPON_W);
  const mat = new THREE.MeshBasicMaterial({ color: COLOR });
  applyStylizedShading(mat, { lightmap, ...SHADING, skin: { seed, ...SKIN } });
  const mesh = new THREE.Mesh(geo, mat);
  return {
    object: mesh,
    dispose: () => { geo.dispose(); mat.dispose(); },
  };
}
